module.exports = __webpack_public_path__ + "static/img/装饰7.7d70757.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰7.svg
// module id = O/9Y
// module chunks = 2